export default __webpack_public_path__ + "static/media/work_with_employers_icon.050a8045.svg";